// extracted by mini-css-extract-plugin
export default {"noDataImage":"EmptyState_noDataImage__2yJzy"};